module.exports = __webpack_public_path__ + "static/media/logo.0fc4318e.svg";